"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableLocales = exports.defaultLanguage = void 0;
/**
 * Дефолтное значение языка (если не передано)
 */
exports.defaultLanguage = 'ru';
/**
 * Доступные локали
 */
exports.availableLocales = { en: 'en', ru: 'ru' };
